import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import { Alert, Typography } from "@mui/material";
import BasicModal from "@/components/basic-modal";
import WF_signalr from "@/modules/crm/automation/workflow-signalr-constants";
import useSignalRClient from "@/services/signal-R/signalr-hubs";
import OnInitHub from "@/services/signal-R/on-receive-hook";
import { getAllRequests } from "@/store/slices/requests";
import { useSelector } from "react-redux";
import WorkflowsSelect from "@/modules/crm/automation/workflow/workflows-select";
import { useRouter } from "next/router";
import guid from "guid";
import { logIt } from "@/services/logger";
import { toast } from "react-toastify";
import { ToastTemplate } from "@/services/variables";
import useManageLead from "@/hooks/leads/useManageLead";
import CreateWorkflowNameModal from "@/modules/crm/automation/workflow/create-name-modal";

const {
  hubName: wf_hubName,
  InvokeMethodNames: { addLeadsToWorkflow },
  onReceiveMethodNames: { addLeadsToWorkflowResponse },
} = WF_signalr;

const AddToWorkflow = (props) => {
  const {
    children,
    leadIds,
    showSuccess = false,
    isDone = false,
    onSaveClicked,
    openfromOutSide = false,
    onCloseOutSide = () => {},
    getWorkflows = true,
  } = props;
  const [open, setOpen] = useState(false);
  const [nameModal, setNameModal] = useState(false);
  const requests = useSelector(getAllRequests);
  const { statuses: wf_statuses, RTC: wf_RTC } = useSignalRClient({
    wf_hubName,
  });
  const workflowHub = wf_RTC[wf_hubName];
  const workflowHubStatus = wf_statuses[wf_hubName];
  const router = useRouter();
  const leadId = Number(router?.query?.id) || props.leadId;
  const [addToWorkflowLoading, setAddToWorkflowLoading] = useState(false);
  const [selectedWorkflows, setSelectedWorkflows] = useState([]);
  const [selectedWorkflowName, setSelectedWorkflowName] = useState("");
  const { clearStateByMethods } = OnInitHub();
  const { getLeadWorkflows } = useManageLead();

  const addToWorkflowHandler = () => {
    if (onSaveClicked) onSaveClicked(selectedWorkflowName);

    const enrollIds = leadIds || [leadId] || [props.leadId];
    const workflowAddLeads = enrollIds.map((leadId) => ({
      workflowId: +selectedWorkflows,
      leadId: +leadId,
    }));
    const payload = {
      workflowAddLeads,
      requestId: guid.raw(),
    };

    setAddToWorkflowLoading(true);

    logIt("log", "lead workflowAddLead", payload);
    if (workflowHubStatus && workflowHub) {
      workflowHub
        .invoke(addLeadsToWorkflow, payload)
        .then((res) => {
          logIt("log", "AddWorkflowAddLead ::res callback", res);
        })
        .catch((err) => {
          logIt("error", "AddWorkflowAddLead ::invoke failed", err);
          setAddToWorkflowLoading(false);
        });
    } else {
      setAddToWorkflowLoading(false);
    }
  };

  const onCloseModal = () => {
    setOpen(false);
    setAddToWorkflowLoading(false);
    setSelectedWorkflows([]);
    setSelectedWorkflowName("");
    clearStateByMethods([addLeadsToWorkflowResponse]);
    onCloseOutSide();
  };

  const onLeadAddedToWorkflow = (response) => {
    const enrollIds = leadIds || [leadId] || [props.leadId];

    if (response && response.isSuccess) {
      toast.success(
        ToastTemplate.success(
          `Lead${
            enrollIds?.length > 1 ? "s" : ``
          } Enrolled in ${selectedWorkflowName} ${
            enrollIds?.length > 1 ? enrollIds?.length : ""
          }.`
        )
      );
    } else if (response?.errors?.length) {
      console.error(
        "onLeadAddedToWorkflow error::",
        response?.errors?.join(", ")
      );
      toast.error(ToastTemplate.error("Something went wrong!"));
    }
  };

  useEffect(() => {
    const response = requests[addLeadsToWorkflowResponse];
    if (!response) return;

    if (showSuccess) {
      onLeadAddedToWorkflow(response);
    }

    if (getWorkflows) getLeadWorkflows(leadId);

    onCloseModal();
  }, [requests[addLeadsToWorkflowResponse]]);

  useEffect(() => {
    if (isDone) {
      onCloseModal();
    }
  }, [isDone]);

  return (
    <>
      <div
        className="add-to-workflow-trigger"
        onClick={() => {
          setAddToWorkflowLoading(false);
          setOpen(true);
        }}
      >
        {children}
      </div>

      {/* Add lead to workflow */}
      <BasicModal
        open={open || openfromOutSide}
        size="sm"
        title="Automations"
        handleClose={onCloseModal}
        saveButtonTitle={"Save"}
        saveCallback={addToWorkflowHandler}
        saveBtnLoading={addToWorkflowLoading}
        modalBodySx={{ padding: "1rem" }}
        saveBtnDisabled={
          typeof selectedWorkflows == "object"
            ? !selectedWorkflows?.length
            : !selectedWorkflows
        }
      >
        <Alert severity="info">
          Enroll leads in efficient automations, saving time and maximizing
          opportunities
        </Alert>
        <WorkflowsSelect
          leadId={leadId}
          onChange={(e, data) => {
            console.log(data);
            setSelectedWorkflowName(data?.name || "");
            setSelectedWorkflows(e);
          }}
        />
        <Box
          className="d-flex align-items-center"
          sx={{ marginTop: "1rem", fontSize: "0.875rem" }}
        >
          Want to create from scratch?&nbsp;
          <Typography
            onClick={() => setNameModal(true)}
            sx={{
              color: "var(--palette-secondary_button_text)",
              textDecoration: "underline",
              fontSize: "0.875rem",
              cursor: "pointer",
            }}
          >
            Create Automation
          </Typography>
        </Box>
      </BasicModal>
      <CreateWorkflowNameModal
        openModal={nameModal}
        handleClose={() => setNameModal(false)}
        redirect={true}
      />
    </>
  );
};
export default AddToWorkflow;
